
import IndexModel from "@/service/v10/seguranca/IndexModel";
 
class UsuarioService extends IndexModel {
      
    
    constructor() {
        super();
        this.url = this.url + '/Usuario';
    }
 
    public getApiUrl() {
        return this.getAxios().defaults.baseURL + this.url;
    }
      

    public getMeusDados() : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
     
    public updateMeusDados(   dados: any ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( this.url  , dados  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
    

     

}
  
export default UsuarioService; 